var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExport = function SvgExport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.625.265l4.24 4.272c.685.682-.342 1.705-1.026 1.023L8.98 2.708c-.14-.14-.255-.092-.255.108v7.867a.725.725 0 11-1.452 0V2.816c0-.199-.114-.248-.255-.108L4.161 5.56c-.684.682-1.71-.34-1.026-1.023L7.348.27A.896.896 0 018.625.265zm5.92 14.762v-2.533c0-.4.326-.724.728-.724.401 0 .727.324.727.724v3.257c0 .6-.491 1.083-1.094 1.083H1.094A1.091 1.091 0 010 15.751v-3.257c0-.4.326-.724.727-.724.402 0 .728.324.728.724v2.533c0 .196.162.36.363.36h12.364a.364.364 0 00.364-.36z",
    clipPath: "url(#clip0_1047_8714)",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1047_8714"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v17H0z"
  })))));
};
export default SvgExport;